import React from 'react';
import { BoxIcon } from 'lucide-react';
interface HolographicButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'success';
  size?: 'md' | 'lg' | 'xl';
  href?: string;
  icon?: BoxIcon;
  fullWidth?: boolean;
}
export function HolographicButton({
  children,
  variant = 'primary',
  size = 'lg',
  href,
  icon: Icon,
  fullWidth = false,
  className = '',
  ...props
}: HolographicButtonProps) {
  const baseClasses = 'btn-holo inline-flex items-center justify-center font-bold text-white rounded-btn shadow-lg';
  const variantClasses = {
    primary: 'bg-primary hover:bg-blue-700',
    success: 'bg-success hover:bg-green-700'
  };
  const sizeClasses = {
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl md:text-2xl'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const combinedClasses = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${widthClass} ${className}`;
  const content = <>
      {children}
      {Icon && <Icon className="ml-2 w-5 h-5 md:w-6 md:h-6" data-id="element-14" />}
    </>;
  if (href) {
    return <a href={href} className={combinedClasses} {...props as any} data-id="element-15">
        {content}
      </a>;
  }
  return <button className={combinedClasses} {...props} data-id="element-16">
      {content}
    </button>;
}